import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IconTypes } from '../../../../../../standalones/components/pencil-icon/pencil-icon.component';

@Component({
  selector: 'app-new-preview-page-item[imageUrl]',
  templateUrl: './new-preview-page-item.component.html',
  styleUrls: ['./new-preview-page-item.component.scss'],
})
export class NewPreviewPageItemComponent implements OnChanges {
  @Input() isSelected = false;
  @Input() pageNumber = -1;
  @Input() imageUrl!: string;
  @Input() width = 0;
  @Input() height = 0;
  @Output() toggleSelection = new EventEmitter();

  protected readonly IconTypes = IconTypes;

  containerStyle: { [key: string]: string | number } = {
    'aspect-ratio': 0.707,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width'] || changes['height']) {
      const computedAspectRatio = this.height ? this.width / this.height : 0.707;
      this.containerStyle['aspect-ratio'] = computedAspectRatio || 0.707;
    }
  }
}
